export enum AdminPayoutActionTypes {
  FETCHING = 'admin-payouts/FETCHING',
  RECEIVED = 'admin-payouts/RECEIVED',
  CREATING = 'admin-payouts/CREATING',
  CREATED = 'admin-payouts/CREATED',
  EXECUTED = 'admin-payouts/EXECUTED',
  EXECUTING = 'admin-payouts/EXECUTING',
}
